import React from "react";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import {
	Container,
	VideoContainer,
	VideoCarousal,
	Heading,
	Description,
	Content,
} from "./style";
import PropTypes from "prop-types";
import VideoElement from "../../Elements/Video";

const VideoWithText = ({
	url,
	header,
	headerFontSize,
	description,
	enableVideoCarousal,
	videoCards,
}) => {
	const settings = {
		dots: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500,
		arrow: false,
	};

	return (
		<div>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>
			<Container>
				<Content>
					<Heading
						fontSize={headerFontSize}
						dangerouslySetInnerHTML={{
							__html: header?.html,
						}}
					></Heading>
					<Description
						dangerouslySetInnerHTML={{
							__html: description?.html,
						}}
					></Description>
				</Content>
				{!enableVideoCarousal && url ? (
					<VideoContainer>
						<VideoElement url={url} />
					</VideoContainer>
				) : (
					<VideoCarousal>
						<Slider {...settings}>
							{videoCards.map((card, index) => {
								return (
									<div key={index}>
										<VideoElement url={card.url} />
										<div className="mentor-info">
											{card.name}, {card.title}, {card.company}
										</div>
									</div>
								);
							})}
						</Slider>
					</VideoCarousal>
				)}
			</Container>
		</div>
	);
};

VideoWithText.defaultProps = {
	url: "",
	header: "",
	description: "",
	enableVideoCarousal: false,
	videoCards: [],
	headerFontSize: "",
};
VideoWithText.propType = {
	url: PropTypes.string,
	header: PropTypes.string,
	description: PropTypes.string,
	enableVideoCarousal: PropTypes.bool,
	videoCards: PropTypes.array,
	headerFontSize: PropTypes.string,
};

export default VideoWithText;
